import { render } from "./InternalTransferUnsuccessful.vue?vue&type=template&id=172d4e78&scoped=true"
import script from "./InternalTransferUnsuccessful.vue?vue&type=script&lang=js"
export * from "./InternalTransferUnsuccessful.vue?vue&type=script&lang=js"

import "./InternalTransferUnsuccessful.vue?vue&type=style&index=0&id=172d4e78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172d4e78"]])

export default __exports__